import { MessageCard } from '~/shared/components/MessageCard';

export enum ExpertProfileErrorVariant {
  NotFound = 'not-found',
  Error = 'error',
}

interface Props {
  variant: ExpertProfileErrorVariant;
  onBack: () => void;
  /** When variant is 'error', optional message to show instead of default description. */
  message?: string;
}

const CONTENT: Record<
  ExpertProfileErrorVariant,
  { title: string; description: string }
> = {
  [ExpertProfileErrorVariant.NotFound]: {
    title: 'Expert not found',
    description:
      'This expert could not be found. Go to the home page to manage your matters and experts.',
  },
  [ExpertProfileErrorVariant.Error]: {
    title: 'Something went wrong',
    description:
      'An error occurred while loading this profile. Please try again.',
  },
};

export function ExpertProfileErrorState(props: Props) {
  const { variant, onBack, message } = props;
  const content = CONTENT[variant];
  const title = content.title;
  const description = message ?? content.description;
  return (
    <MessageCard
      title={title}
      description={description}
      buttonLabel="Back to home"
      onButtonClick={onBack}
    />
  );
}
